import React from 'react'
import { useTranslation } from 'react-i18next'
import DeleteOutlinedIcon from '@material-ui/icons/DeleteOutlined';
import NotificationsOutlinedIcon from '@material-ui/icons/NotificationsOutlined';
import Menu from '../../../../styled-base/menu';
import { imgUrl } from '../../../../utils/url';

type MenuProps = {
  menuId: string,
  title: string,
  handler: (item: any) => void,
  item: any,
  iconSrc: any,
  iconAlt: any,
}

type TabHamburgMenuProps = {
  menu: {
    items: MenuProps[],
  },
}

const TabHamburgMenu = ({ menu }: TabHamburgMenuProps) => {
  const { t } = useTranslation()
  const { items } = menu;

  const onHandler = (m: any) => {
    if (typeof m.handler === 'function') {
      m.handler(m.item || '');
    }
  }

  if (!Array.isArray(items) || !items.length) {
    return null;
  }

  return (
    <Menu
      kebabColor="#cccccc"
      kebabSize="20px"
      isBottom
      fixedWidth="160px"
    >
      {
        items.map((m: MenuProps, i: number) => (
          <Menu.Item key={m.menuId} disabled={false} onClick={() => onHandler(m)}>
            {(m.menuId == 'delete'
              && <DeleteOutlinedIcon fontSize="small" htmlColor="#a6b6bc" />)}
            {
              (m.menuId == 'ping'
                && <NotificationsOutlinedIcon fontSize="small" htmlColor="#a6b6bc" />)
            }
            {
              (m.menuId == 'convert_sub_ai'
                && <img src={imgUrl('/images/icons/dropdowns/action_items@3x.png')} alt={t('Convert to subtask')} width="19" />)
            }
            {
              (m.menuId == 'convert_ai'
                && <img src={imgUrl('/images/icons/dropdowns/subactions@3x.png')} alt={t('Convert to action item')} width="19" />)
            }
            {
              (m.menuId == 'full_details'
                && <img src={imgUrl('/images/icons/board/full_details@2x.png')} alt={t('View action details')} width="15" />)
            }
            {
              (m.iconSrc && m.iconAlt
                && <img src={imgUrl(m.iconSrc)} alt={m.iconAlt} width="19" />
              )
            }
            <span>{m.title}</span>
          </Menu.Item>
        ))
      }
    </Menu>
  )
}

export default TabHamburgMenu;
